import _ from "lodash";

require('../../bootstrap');

import Vue          from 'vue';
import ComponentSet from "../../ComponentSet";

import utils from "../../Utils";
import moment from 'moment';
import Constants from "../../Constants";

import Swiper, {Autoplay, EffectFade, Navigation, Pagination} from "swiper";
// import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';

// import overlayscrollbars
import 'overlayscrollbars/css/OverlayScrollbars.css';
import {OverlayScrollbarsComponent, OverlayScrollbarsPlugin} from 'overlayscrollbars-vue';

// global registration
Vue.component('overlay-scrollbars', OverlayScrollbarsComponent);

const components = _.merge(ComponentSet,
    {
        'overlay-scrollbars': OverlayScrollbarsComponent
    });

// --------------------------------------------------------------
//                          主程式
// --------------------------------------------------------------
const app = new Vue({
    components: components,
    mixins: [utils],
    data() {
        return {
            deviceWidth: {
                type: Number,
                default: 0
            }
        };
    },
    created() {
        // 使用 Utils 的 method 設定
        //defaultOnCreated(this);
        this.deviceWidth = window.innerWidth;
    },
    beforeDestroy() {

    },
    mounted() {
        let self = this;
        // 取回該頁面需要用到的資料
        this.retrieveSiteContentData(function() {
            self.$nextTick(function() {
                // banner initialize
                const banner_swiper = new Swiper(".banner_swiper", {
                    // configure Swiper to use modules
                    modules: [Navigation, Autoplay, EffectFade],
                    // Optional parameters
                    loop: true,
                    effect: 'fade',
                    autoplay:true,
                    // Navigation arrows
                    navigation: {
                        nextEl: ".banner-button-next",
                        prevEl: ".banner-button-prev",
                    },
                    on: {
                        slideChange:function(swiper){
                            $('.banner_swiper .scroll-txt h3').hide();
                            $('.banner_swiper .scroll-txt h3').eq(swiper.realIndex).show()
                        }
                    }
                }); // end of swiper

                // 向下捲動event & +class
                $(window).bind('scroll',function(e){
                    const scrolled = $(window).scrollTop();
                    $('.rd-milestones').each(function(){
                        if ( (scrolled + $(window).height()) >= $(this).offset().top) {
                            const yearKey = $(this).data('year');
                            if(!$('#year-'+yearKey).hasClass('now')){
                                $('.rd-year').removeClass('now');
                                $('#year-'+yearKey).addClass('now');
                            }
                        }
                    })
                });

                // 年度，點擊後滑動到對應的區域
                $('.rd-year').on('click', function(){
                    const yearKey = $(this).data('year');
                    $("html, body").animate({ scrollTop: ($('#milestone-'+yearKey).offset().top - $('.cgmhtop_box').height()) }, 300);
                });
                
                
            });
        });        
    },
    methods: {
        showMonthDay(dateString, locale = null) {
            let date = moment(dateString);

            if (locale) {
                date.locale(locale)
            }
            return date.format('MM/DD')
        },
    }, // end of methods
    computed: {
        serverRoot() {
            return Constants.serverRoot
        },
        milestonesData() {
            return _.get(this, 'contentData.milestonesList', []) || [];
        },
        bannersData() {
            return _.get(this, 'contentData.bannerList', []) || [];
        },
    }, // end of computed
}).$mount('#app');